// Put any external JS or custom JS you wish for the theme here.

import "core-js/stable";
import './package'

(function (w, $, wp) {
    const setValueCssIEGap = () => {
        if ($('.wp-block-my-block-gap').length != 0) {
            $(".wp-block-my-block-gap").each(function (index) {
                let dataDF = $(this).data('size-default');
                let dataTablet = $(this).data('size-tablet');
                let dataMobile = $(this).data('size-mobile');
                $(this).css('height', dataDF);
                if ($(window).width() < 768) {
                    $(this).css('height', dataTablet);
                }
                if ($(window).width() < 425) {
                    $(this).css('height', dataMobile);
                }
            });
        }
    }

    const fullpageSlideBackground = () => {
        $('.background-layer').each(function () {
            const $el = $(this)
            $el.css({
                backgroundImage: `url( ${$el.data('bg-url')} )`
            });
        })
    }

    const bsaAnchorLinkAcc = () => {
        let anchorID = window.location.hash;
       
        if (!anchorID) return;

        if (!$(anchorID).length) return;

        let qaItem = $(anchorID).find('.qa-item'),
            qaAnswer = $(anchorID).find('.qa-answer');

        if (!qaItem.hasClass('qa-item-open')) {
            qaItem.addClass('qa-item-open');
            qaAnswer.show();
        }

        setTimeout(() => {
            $('body, html').stop().animate({
                scrollTop: $(anchorID).offset().top
            }, 500)
        }, 400)
    }

    const bsaHandleAnchorLinkAcc = () => {
        $('.qa-item .qa-answer a').click(function(e){
           
            let anchorID = $(this).attr('href');
            if (!$(anchorID).length) return;
           
            let qaItem = $(anchorID).find('.qa-item'),
            qaAnswer = $(anchorID).find('.qa-answer');
           
            if (!qaItem.hasClass('qa-item-open')) {
                $('body, html').stop().animate({
                    scrollTop: $(anchorID).offset().top - 20
                }, 500)
                qaItem.addClass('qa-item-open');
                qaAnswer.show();
            }
        })
    }

    // Document ready
    $(() => {
        let socials = document.querySelectorAll('.wp-block-social-links a');
        socials.forEach(function (vl, key) {
            vl.target = "_blank"
        })

        //fullpageSlideBackground();

    })

    // Browser load completed
    $(w).load(function () {
        let ua = window.navigator.userAgent;
        let isIE = /MSIE|Trident|Edge\//.test(ua);

        if (isIE) {
            setValueCssIEGap();
            $(window).resize(function () {
                setValueCssIEGap();
            });
        }

        bsaAnchorLinkAcc();
        bsaHandleAnchorLinkAcc()
    });
})(window, jQuery, window.wp);
